var staticsUrl =
  process.env.NODE_ENV === 'production'
    ? '//groups.wixapps.net/groups-server/api/statics'
    : 'http://localhost:3000/api/statics'

function createTranslationsGetter(translations) {
  return function (key) {
    return translations[key] ? translations[key] : key
  }
}

module.exports = function loadTranslations(translationsName, language) {
  var url = staticsUrl + '/groups-translations/' + translationsName + '_' + language + '.json'

  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest()
    xhr.open('GET', url, true)
    xhr.onload = function () {
      try {
        var translations = JSON.parse(xhr.responseText)
        if (xhr.readyState === 4 && xhr.status === 200) {
          resolve({t: createTranslationsGetter(translations), translations: translations})
        } else {
          reject({readyState: xhr.readyState, status: xhr.status})
        }
      } catch (e) {
        reject(xhr)
      }
    }
    xhr.send()
  })
}
